import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Button,
} from "reactstrap";

export default function LogoutModel({ modal, setModal }) {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Logout
      </ModalHeader>
      <ModalBody>Are Your Sure You Want To Logout ?</ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            logout();
            setModal((state) => !state);
          }}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={() => setModal((state) => !state)}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
}
